var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SingleColumn',{attrs:{"md":"4","offset-md":"4"}},[_c('PCard',{staticClass:"px-3 text-left"},[_c('div',{staticClass:"subtitle bold"},[_vm._v(" "+_vm._s(_vm.$t('common:sorry'))+" ")]),_c('div',{staticClass:"text-left subtitle mt-3 mb-4"},[_vm._v(" "+_vm._s(_vm.$t('nav:page_not_found'))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }